export default "__VITE_ASSET__BCQKfom$__"